export default __webpack_public_path__ + "maps-examples-line-gradient-960-4361d740ca83a6b00576f828bb01afa3.webp";